<template>
  <v-app>
    <v-app-bar
      app
      color="second"
      dark
      flat
    >
      <div class="d-flex align-center">
        <i>Theme LAB</i>
      </div>
      <v-text-field
          hide-details
          label="Filled"
          placeholder="Search"
          filled
          rounded
          dense
          single-line
          append-icon="mdi-magnify" class="shrink mx-4"
          v-model="filter"
      >
      </v-text-field>
      <v-spacer></v-spacer>
      <div class="align-center d-none d-sm-block">
        <i>주식 테마를 한눈에 담다</i>
      </div>
    </v-app-bar>

    <v-content>
      <Themelap :type="type" :filter="filter" />
      <!--<div style="background-color: black">
        <CandleStick :stock="stock" />
      </div>
      <div style="background-color: green">
         <CandleStick :stock="stock2" />
      </div>
        <div style="background-color: yellow">
            <CandleStick :stock="stock3" />
        </div>-->
    </v-content>

    <v-dialog
        v-model="dialog"
        max-width="290"
    >
      <v-card>
        <v-card-title class="headline">테마랩</v-card-title>
        <v-card-text>
          Contact: themelab
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Themelap from './components/Themelap';
import CandleStick from "./components/CandleStick";

export default {
  name: 'App',

  components: {
    CandleStick,
    Themelap,
  },

  data: () => ({
    dialog: false,
    type: 'theme',
    filter: '',
    stock: {
      closePrice: 6040,
      code: "A103840",
      highRate: "6.77",
      lowRate: "0.17",
      openingRate: "0.17",
      rate: "4.86",
      tradePrice: 9505004300,
      tradeVolume: 1586440,
      type: "Stock",
      warning: "",
    },
      stock2: {
          closePrice: 6040,
          code: "A103840",
          highRate: "29.1",
          lowRate: "-5.17",
          openingRate: "0.17",
          rate: "15.86",
          tradePrice: 9505004300,
          tradeVolume: 1586440,
          type: "Stock",
          warning: "",
      },
      stock3: {
          closePrice: 6040,
          code: "A103840",
          highRate: "5.1",
          lowRate: "-29.17",
          openingRate: "-3.17",
          rate: "-10.86",
          tradePrice: 9505004300,
          tradeVolume: 1586440,
          type: "Stock",
          warning: "",
      }
  }),

  methods: {
    info () {
      this.dialog = true;
    },
  },
};
</script>
